import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { CONTACT } from 'config/contact';

const TermsOfService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Terms of Service | Make Mind Automations</title>
        <meta
          name="description"
          content="The terms that apply when you use the Make Mind Automations website and work with us."
        />
        <link rel="canonical" href="https://makemindautomations.tech/terms" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        <main className="py-20">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-4xl font-bold text-text-primary mb-4">Terms of Service</h1>
            <p className="text-text-secondary mb-10">Last updated: October 24, 2026</p>

            <div className="space-y-10 text-text-secondary leading-relaxed">
              <section>
                <h2 className="text-2xl font-bold text-text-primary mb-3">About these terms</h2>
                <p>
                  These terms apply to your use of this website. When you engage us for a project,
                  the proposal or agreement for that project applies alongside these terms, and if
                  they conflict, the project agreement wins.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-text-primary mb-3">Our services</h2>
                <p>
                  We provide automation, AI, and digital marketing services, including workflow
                  builds, chatbots, integrations, SEO, paid advertising, social media, content, and
                  email marketing. Service descriptions on this site are general; the exact scope,
                  timeline, and price for your project are set out in your proposal.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-text-primary mb-3">Your responsibilities</h2>
                <p>
                  You agree to give us accurate information, timely access to the accounts and tools
                  needed for the work, and feedback within the timelines in your proposal. You are
                  responsible for the content you provide and for complying with the advertising and
                  platform policies that apply to your business.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-text-primary mb-3">Ownership</h2>
                <p>
                  Workflows, content, and accounts we build for you belong to your business once
                  paid for in full. We may reuse general techniques and know-how gained across
                  projects, but never your confidential business data.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-text-primary mb-3">Payments and cancellation</h2>
                <p>
                  Retainers and one-time fees are billed as set out in your proposal. You may cancel
                  a monthly retainer with notice as stated in your proposal; work already delivered
                  is not refundable. Any money-back guarantee that applies to your plan is described
                  in your proposal.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-text-primary mb-3">Liability</h2>
                <p>
                  We build and test carefully, but third-party platforms change their rules and APIs
                  without notice. To the extent permitted by law, our liability for any claim is
                  limited to the fees you paid for the affected service in the three months before
                  the claim.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-text-primary mb-3">Governing law</h2>
                <p>
                  These terms are governed by the laws of India. Disputes will be handled by the
                  courts in Gurgaon, Haryana.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-text-primary mb-3">Contact us</h2>
                <p>
                  Questions about these terms? Email us at{' '}
                  <a className="text-primary" href={`mailto:${CONTACT.email}`}>
                    {CONTACT.email}
                  </a>
                  .
                </p>
              </section>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default TermsOfService;
